import styled from "styled-components";

export const AddToCartButton = styled.button`
  /* Copied from skbv-frontend */
  .button-loader,
  .button-loader-ellipsis {
    display: none;
  }

  &.is-disabled {
    position: relative;
    text-indent: -9999px;
    cursor: unset;
    pointer-events: none;

    .button-loader {
      position: absolute;
      display: inline-block;
      height: 52px;
      width: 100%;
      top: 0;
      right: 0;
    }

    .button-loader-ellipsis:before,
    .button-loader-ellipsis:after,
    .button-loader-ellipsis {
      display: inline-block;
      border-radius: 50%;
      width: 20px;
      height: 20px;
      -webkit-animation-fill-mode: both;
      animation-fill-mode: both;
      -webkit-animation: ellipsis-loader 1.5s infinite ease-in-out;
      animation: ellipsis-loader 1.5s infinite ease-in-out;
    }

    .button-loader-ellipsis {
      color: $color-white;
      font-size: 18px;
      position: absolute;
      top: -29px;
      left: 50%;
      text-indent: -9999em;
      animation-delay: -0.14s;
    }

    .button-loader-ellipsis:before {
      left: -30px;
      -webkit-animation-delay: -0.2s;
      animation-delay: -0.2s;
    }

    .button-loader-ellipsis:after {
      left: 30px;
    }

    .button-loader-ellipsis:before,
    .button-loader-ellipsis:after {
      content: "";
      position: absolute;
      top: 0;
    }

    @-webkit-keyframes ellipsis-loader {
      0%,
      80%,
      100% {
        box-shadow: 0 2.5em 0 -1.3em;
      }
      40% {
        box-shadow: 0 2.5em 0 0;
      }
    }

    @keyframes ellipsis-loader {
      0%,
      80%,
      100% {
        box-shadow: 0 2.5em 0 -1.3em;
      }
      40% {
        box-shadow: 0 2.5em 0 0;
      }
    }
  }
`;
